// React Component (or JSX)

import React from 'react';
import './App.css'; // Assuming you have a CSS file for styles

const Anthony_ShawPR_Azure_Samples_azure_search_openai_demo_pull_2553_From_2025_6_01_To_2025_6_30 = () => {
  return (
    <>
     <a
        href="https://github.com/tonybaloney?tab=overview&from=2025-06-01&to=2025-06-30"
        target="_blank"
        rel="noopener noreferrer"
      >
        Overview of commits/PRs from Jun 1, 2025 to Jun 30, 2025
      </a>
<div>
<a
        href="https://github.com/tonybaloney?tab=overview&from=2025-06-01&to=2025-06-30"
        target="_blank"
        rel="noopener noreferrer"
      >
        Backend URL Link  https://github.com/tonybaloney?tab=overview&from=2025-06-01&to=2025-06-30
      </a>
</div>
      
    
<h1 style={{ margin: 0 }}
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
><bdi className="Box-sc-g0xbh4-0 lhNOUb markdown-title" data-testid="issue-title">Speed up prepdocs for file strategy with parallel async pools</bdi>

  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/Azure-Samples/azure-search-openai-demo/pull/2553" target="_blank" rel="noopener noreferrer">
  #2553
    </a>
   
    </span>
</h1>

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/tonybaloney" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">tonybaloney</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>commented </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/Azure-Samples/azure-search-openai-demo/pull/2553" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Jun 2, 2025</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
</div>

<p>Here are the details of a specific PR from the <a href="https://github.com/Azure-Samples/azure-search-openai-demo/pull/2553" target="_blank">Azure-Samples/azure-search-openai-demo repository</a>:</p>

    </>
  );
};

export default Anthony_ShawPR_Azure_Samples_azure_search_openai_demo_pull_2553_From_2025_6_01_To_2025_6_30;
